import { render, staticRenderFns } from "./RecoveryControls.vue?vue&type=template&id=676f3254&"
import script from "./RecoveryControls.vue?vue&type=script&lang=js&"
export * from "./RecoveryControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports